import React from 'react';
import { useNavigation } from './LanguageContext';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  href?: string;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({ children, variant = 'primary', href, className = '', ...props }) => {
  const { path, navigate } = useNavigation();

  const baseClasses = "inline-block px-8 py-3 text-lg font-semibold rounded-lg transition-all duration-300 transform focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    primary: 'bg-black text-white dark:bg-white dark:text-black hover:bg-accent hover:text-accent-foreground focus:ring-accent',
    secondary: 'bg-accent text-accent-foreground hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black focus:ring-black dark:focus:ring-white'
  };

  const combinedClasses = `${baseClasses} ${variantClasses[variant]} ${className}`;

  if (href) {
    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      
      if (href.startsWith('#')) {
        const id = href.substring(1);
        const scrollToSection = () => {
            const element = document.getElementById(id);
            if (element) {
                const headerOffset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
            }
        };
        
        if (path !== '/') {
            navigate('/');
            setTimeout(scrollToSection, 100);
        } else {
            scrollToSection();
        }
      } else {
          navigate(href);
      }
    };
    
    const hashHref = href.startsWith('#') ? href : `#${href}`;

    return (
      <a href={hashHref} onClick={handleLinkClick} className={combinedClasses}>
        {children}
      </a>
    );
  }

  return (
    <button className={combinedClasses} {...props}>
      {children}
    </button>
  );
};

export default Button;